import { VipLevelRewardFormValues } from './types';

export const VIP_LEVEL_REWARD_FORM_INITIAL_VALUES: VipLevelRewardFormValues = {
  title: '',
  levelRewards: [],
  order: 0,
  reuseInterval: 0,
  isDisabled: false,
};
